import { IS_MOBILE } from '@utilities/browser';

export type PromoAppDownloadOptions = {
  btnUrl: string;
};

const defaults: PromoAppDownloadOptions = {
  btnUrl: '',
};

export default class PromoAppDownloadPlugin {
  options: PromoAppDownloadOptions;
  dom: HTMLElement;
  pkDownloadBtn: HTMLPkButtonElement;
  pkNoDownloadBtn: HTMLPkButtonElement;
  pkBottomPanel: HTMLPkBottomPanelElement;

  constructor(dom: HTMLElement, o: PromoAppDownloadOptions) {
    this.dom = dom;
    this.options = { ...defaults, ...o };
    this.pkDownloadBtn = this.dom.querySelector('.download-app');
    this.pkNoDownloadBtn = this.dom.querySelector('.no-download-app');
    this.pkBottomPanel = this.dom.closest('pk-bottom-panel');
  }

  init() {
    this.setUrl();

    this.pkNoDownloadBtn.addEventListener('click', () => {
      this.pkBottomPanel.close();
    });
  }

  setUrl() {
    const isIOs = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isMobile = IS_MOBILE;
    const urls = [];

    this.options.btnUrl.split(',').forEach((v, i) => {
      urls[i] = v;
    });

    const desktopUrl = urls[0];
    const mobileUrl = urls[1];
    const IOsUrl = urls[2];

    this.pkDownloadBtn.linkHref = desktopUrl;

    if (isIOs && IOsUrl) {
      this.pkDownloadBtn.linkHref = IOsUrl;
    } else if (isMobile && mobileUrl) {
      this.pkDownloadBtn.linkHref = mobileUrl;
    }
  }
}
